import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ShieldAlert } from "lucide-react";
import { useSEO } from "../lib/useSEO";

export default function Terms() {
  const [terms, setTerms] = useState(null);
  useSEO({ title: "Contractor Liability & Terms", description: "Kootenay Home Pros contractor liability and indemnification agreement. Contractors assume full liability for work performed." });

  useEffect(() => {
    api.get("/terms/contractor-liability").then(({ data }) => setTerms(data));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-10 py-16">
      <div className="overline text-[#B85C47] mb-3">Legal</div>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight mb-2" style={{ fontFamily: "Outfit" }}>
        {terms?.title || "Contractor Liability & Indemnification Agreement"}
      </h1>
      <div className="text-sm text-stone-500 mb-10">
        Version {terms?.version || "1.0"} · Effective {terms?.effective_date || "2026-01-01"}
      </div>

      <div className="bg-[#FBF6EE] border-2 border-[#B85C47]/30 rounded-xl p-6 mb-10 flex gap-3">
        <ShieldAlert className="w-6 h-6 text-[#B85C47] shrink-0 mt-0.5" />
        <p className="text-sm text-stone-800 leading-relaxed">
          Kootenay Home Pros is a directory and connection platform only. All liability for work performed rests entirely with the contractor. Homeowners are encouraged to verify licenses and insurance before hiring.
        </p>
      </div>

      <div className="prose prose-stone max-w-none whitespace-pre-line text-stone-700 leading-relaxed">
        {terms?.body || "Loading terms…"}
      </div>

      <div className="mt-12 p-6 bg-white border border-[#E2DCD0] rounded-xl">
        <h3 className="font-bold text-lg tracking-tight mb-2" style={{ fontFamily: "Outfit" }}>Questions?</h3>
        <p className="text-sm text-stone-600">
          Contact us at <a href="mailto:hello@kootenayhomepros.ca" className="text-[#B85C47] font-semibold">hello@kootenayhomepros.ca</a>.
        </p>
      </div>
    </div>
  );
}
